import {
  UnitAndCalories,
  DrinkingDay,
  DrinksWithTotal,
  DrinksPerDay,
  UnitsAndCaloriesPerDay
} from "@dcc/types/drinkingDay";
import { DrinkFrequency } from "@dcc/types/drinkFrequency";
import { dailyUnitAndCaloriesConverter } from "./weeklyConverters";
import { monthlyUnitAndCaloriesConverter } from "./monthlyConverters";
import { pipe } from "@dcc/common/functionalUtils";
import { Drinks } from "@dcc/types/drinks";
import { roundToNDecimalPlaces } from "@dcc/common/rounding";
import { drinkUnitAndCalories } from "@dcc/constants/drinkConstants";

export const getDailyUnitsAndCalories = ({
  totalWeeklyUnitsAndCalories,
  drinkFrequency,
  numberOfWeeklyDrinkingDays,
  numberOfMonthlyDrinkingDays
}: {
  totalWeeklyUnitsAndCalories: UnitAndCalories;
  drinkFrequency: DrinkFrequency;
  numberOfWeeklyDrinkingDays: number;
  numberOfMonthlyDrinkingDays: number;
}): UnitAndCalories => {
  const converter = pipe(
    dailyUnitAndCaloriesConverter(numberOfWeeklyDrinkingDays)[drinkFrequency],
    monthlyUnitAndCaloriesConverter(numberOfMonthlyDrinkingDays)[drinkFrequency]
  );

  return {
    units: converter(totalWeeklyUnitsAndCalories.units),
    calories: converter(totalWeeklyUnitsAndCalories.calories)
  };
};

const sumDrinkingDayValue = (day: DrinkingDay, value: keyof UnitAndCalories) =>
  Object.keys(Drinks).reduce((agg, curr) => {
    const currentDrink = curr as Drinks;
    agg += roundToNDecimalPlaces(
      drinkUnitAndCalories[currentDrink][value] * day[currentDrink],
      2
    );
    return agg;
  }, 0);

const getTotalCaloriesForDay = (day: DrinksWithTotal) =>
  sumDrinkingDayValue(day, "calories");

const getTotalUnitsForDay = (day: DrinksWithTotal) =>
  sumDrinkingDayValue(day, "units");

export const getCaloriesAndUnitsForEachday = (
  days: DrinksPerDay[]
): UnitsAndCaloriesPerDay[] =>
  days.map((day) => ({
    calories: getTotalCaloriesForDay(day),
    units: getTotalUnitsForDay(day),
    day: day.day
  }));
